module.exports = __webpack_public_path__ + "img/11.19a856a3.jpg";